const STATUS_CONFIG = {
  1: { label: 'Activo', tone: 'bg-emerald-400/10 text-emerald-300/90 ring-emerald-300/20' },
  99: { label: 'Inactivo', tone: 'bg-rose-400/10 text-rose-300/90 ring-rose-300/20' },
};

const FALLBACK = { label: '—', tone: 'bg-white/5 text-white/50 ring-white/10' };

function EstadoActivoPill({ status }) {
  const config = STATUS_CONFIG[status] ?? FALLBACK;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10px] font-mono uppercase tracking-[0.14em] ring-1 ${config.tone}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {config.label}
    </span>
  );
}

export default EstadoActivoPill;